import {atom} from "recoil";
import {SelectElementModelFE} from "../api/types/generic";
import {BASE_DEFINITION_FORM_STEPS} from "../constants";
import {FormSearchOWAncillaryModel, OWAncillaryCreation, OWAncillaryEntityResponse} from "../api/types/owAncillary";
import {AncillarySelectFE} from "../api/types/ancillary";

export const owAncillarySelectAtom = atom<AncillarySelectFE[]>({
    key: "owAncillarySelectAtom",
    default: []
});

export const owAncillaryListAtom = atom<SelectElementModelFE[]>({
    key: "owAncillaryListAtom",
    default: []
});

export const owAncillaryAtom = atom<OWAncillaryEntityResponse | null>({
    key: "owAncillaryAtom",
    default: null
});

export const initialOWAncillaryFilters: FormSearchOWAncillaryModel = {
    ancillaryCode: "",
    commercialSegmentId: null,
    pickupDateFrom: "",
    pickupDateTo: "",
    reservationFrom: "",
    reservationTo: "",
    dealers: [],
    legalEntities: []
};
export const owAncillaryFiltersAtom = atom<FormSearchOWAncillaryModel>({
    key: "owAncillaryFiltersAtom",
    default: initialOWAncillaryFilters
});

export const initialOWAncillaryCreation: OWAncillaryCreation = {
    step: BASE_DEFINITION_FORM_STEPS.DEFINITION,
    readOnly: true,
    inUse: false,
    completed: [false, false, false]
};
export const owAncillaryCreationAtom = atom({
    key: "owAncillaryCreationAtom",
    default: initialOWAncillaryCreation
});
